export class ImageDimensions {
    public width: number;
    public height: number;
    constructor() {
        this.width = 0;
        this.height = 0;
    }
}

export enum Resolutions {
    Low,
    High,
    Original
}

enum Widths {
    Low = 800,
    High = 1920
}

enum Heights {
    Low = 600,
    High = 1080
}

export function calcScaledImageDimensions(
    image: HTMLImageElement | HTMLCanvasElement | HTMLVideoElement | ImageBitmap,
    maxWidth: number = Widths.Low,
    maxHeight: number = Heights.Low,
    enlarge?: boolean,
    keepOriginal?: boolean): ImageDimensions {
    let imageDimensions = new ImageDimensions();
    let factorX: number = image.width / maxWidth;
    let factorY: number = image.height / maxHeight;

    // Behoud aspect ratio; altijd vergroten of verkleinen tot de grootste factor
    let factor: number = keepOriginal ? 1 : Math.max(factorX, factorY);
    if (factor > 1 || (factor < 1 && enlarge)) {
        imageDimensions.width = image.width / factor;
        imageDimensions.height = image.height / factor;
    } else {
        imageDimensions.width = image.width;
        imageDimensions.height = image.height;
    }

    return imageDimensions;
}

export function drawImageOnCanvas(canvas: HTMLCanvasElement, image: HTMLImageElement | HTMLCanvasElement | HTMLVideoElement | ImageBitmap, maxWidth?: number, maxHeight?: number, enlarge?: boolean, keepOriginal?: boolean): void {
    let imageDimensions: ImageDimensions = calcScaledImageDimensions(image, maxWidth, maxHeight, enlarge, keepOriginal);
    canvas.width = imageDimensions.width;
    canvas.height = imageDimensions.height;
    if (Modernizr && Modernizr.canvas === false) {
        console.log("Modernizr: canvas not supported.");
    } else {
        let ctx: CanvasRenderingContext2D | null = canvas.getContext('2d');
        if (ctx !== null) {
            ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
        }
    }
}

export function convertImageToBase64Png(img: HTMLImageElement | HTMLCanvasElement | HTMLVideoElement | ImageBitmap, resolution: number = Resolutions.Low): string {
    let canvas = document.createElement("canvas");
    let enlarge = false, keepOriginal = false;
    let width = undefined, height = undefined;
    if (resolution === Resolutions.High) {
        width = Widths.High;
        height = Heights.High;
        enlarge = true;
    } else if (resolution === Resolutions.Original) {
        keepOriginal = true;
    }

    drawImageOnCanvas(canvas, img, width, height, enlarge, keepOriginal);
    return canvas.toDataURL("image/png");
}

export function convertImageFileToBase64Png(file: File, onLoad: (base64png: string) => void, onError: () => void, resolution?: number): void {
    let imgURL: string = (window.URL || (<any>window).webkitURL).createObjectURL(file);
    let imageElem: HTMLImageElement = new Image();
    imageElem.onload = function () {
        onLoad(convertImageToBase64Png(imageElem, resolution));
    };
    imageElem.onerror = function () {
        onError();
    };
    imageElem.src = imgURL;
}
